import { Youtube, Instagram } from 'lucide-react';
import contactLogo from "../../image/contact/contact-logo.png";

interface FooterProps {
  onTermsClick?: () => void;
  onPrivacyClick?: () => void;
}

export function Footer({ onTermsClick, onPrivacyClick }: FooterProps) {
  return (
    <div
      className="bg-[#ececf0] py-12 lg:py-16 relative shrink-0 w-full"
      data-name="Footer Container"
    >
      <div className="box-border content-stretch flex flex-col lg:flex-row gap-4 lg:gap-0 items-start justify-between left-1/2 px-4 relative translate-x-[-50%] w-[min(1280px,_calc(100vw_-_40px))]">
        {/* Footer Info */}
        <div className="flex flex-col gap-4 lg:gap-8">
          {/* Footer Links */}
          <div className="flex gap-4 pb-4 border-b border-[#bdbdbd]">
            <button 
              onClick={onTermsClick}
              className="font-paperlogy font-medium text-[min(14px,_3vw)] text-neutral-950 hover:text-[#cacc2f] transition-colors tracking-[-0.28px]">
              이용약관
            </button>
            <button 
              onClick={onPrivacyClick}
              className="font-paperlogy font-medium text-[min(14px,_3vw)] text-neutral-950 hover:text-[#cacc2f] transition-colors tracking-[-0.28px]">
              개인정보처리방침
            </button>
          </div>

          {/* Business Info */}
          <div className="font-paperlogy font-normal text-[min(14px,_3vw)] text-[#333333] leading-normal tracking-[-0.28px] space-y-1">
            <p className="font-medium mb-2">회사명: (주)아이아이파크 | 대표자: 김인철</p>
            <p>대표전화 : 053-642-5533</p>
            <p>팩스 : 053-289-0298</p>
            <p>E-mail : insolmnt@gmail.com</p>
            <p>벅스어드벤처 디지털키즈카페 : 대구시 달서구 조암남로32길 20-4 6층</p>
            <br />
            <p className="text-[min(12px,_2.8vw)] text-[#666666]">Copyright© (주)아이아이파크. All rights reserved.</p>
          </div>
        </div>

        {/* Social Media & Logo */}
        <div className="flex flex-col items-start lg:items-end gap-8 lg:gap-16">
          {/* Social Media Icons */}
          <div className="flex gap-4">
            {/* 유튜브 버튼 */}
            <a 
              href="https://www.youtube.com/@insolmnt" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-12 h-12 bg-[#FCFCFC] rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
            >
              <Youtube size={24} className="text-gray-600" />
            </a>
            {/* 인스타그램 버튼 */}
            <a 
              href="https://www.instagram.com/bugskidscafe/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-12 h-12 bg-[#FCFCFC] rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
            >
              <Instagram size={24} className="text-gray-600" />
            </a>
          </div>

          {/* Footer Logo */}
          <div className="flex items-end gap-2 lg:flex-col lg:items-end lg:gap-2 opacity-80">
            <div
              className="h-8 w-48 bg-center bg-cover bg-no-repeat opacity-60"
              style={{ backgroundImage: `url('${contactLogo}')` }}
            />
            <div className="text-2xl text-[rgba(0,0,0,0.6)] font-paperlogy font-bold tracking-[-0.48px] leading-[1.2]">
              디지털 키즈카페
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}